<template>
  <div class="container-fluid" >
    <div id="cont" class="text-center mb-5 container">
        <div class="row mx-auto">
      <div id="partner" class="col-lg-5 key p-3 btn btn-primary mx-auto">
        <h2 @click="toggle = true">Become a Key Partner</h2>
      </div>
      <div class="col-lg-5 corp p-3 btn btn-primary mx-auto">
        <h2  @click="toggle = false">Become a Corporate Key Partner</h2>
      </div></div>
    </div>

    <BecomeKeyPartner v-if="toggle"/>

    <BecomeCorporateKeyPartner v-else/>
  </div>
</template>

<script>
import BecomeKeyPartner from "../views/BecomeKeyPartner.vue";
import BecomeCorporateKeyPartner from "../views/BecomeCorporateKeyPartner.vue";

export default {
  name: "becoming-partners",
  components: {
    BecomeKeyPartner,
    BecomeCorporateKeyPartner
  },
  data() {
    return {
      toggle: true,
      toggle2: false,
    };
  },

};
</script>

<style scoped>

.key{background-color: #1B8BB0;}

.key:hover{
   background-color: #105269;
  /* border-color: rgb(131, 112, 152); */
  border: 1px solid #105269;
}

/* .corp{background-color:yellow} */
.col{
    height:128px
}

h2 {
  font-size: 2rem;
}

</style>
